import moment from 'moment'

const formatDate = (value, withTz, withFormat = true) => {
  const date = moment.isMoment(value) ? value : moment(value)

  const zonedDate = withTz ? date.clone().tz(moment.tz.guess()) : date

  if (!withFormat) {
    return zonedDate
  }

  return withTz
    ? withFormat ? date.tz(moment.tz.guess()).format() : date.tz(moment.tz.guess())
    : withFormat ? date.format('YYYY-MM-DD HH:mm') : date
}

const setQueryParams = (filters, context, prefix = '', withTz = false) => {
  const params = new URLSearchParams()

  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === '' || value === null) {
      continue
    }

    const paramKey = prefix ? `${prefix}-${key}` : key

    if (moment(value, ['YYYY-MM-DD HH:mm', 'DD.MM.YYYY HH:mm', 'YYYY-MM-DDTHH:mm:ssZ'], true).isValid()) {
      params.set(paramKey, formatDate(value, withTz))
    } else {
      params.set(paramKey, value)
    }
  }

  const queryString = params.toString().replace(/\+/g, '%20')
  const fullPath = `${context.$route.path}${queryString ? `?${queryString}` : ''}`

  if (context.$route.fullPath === fullPath) {
    return
  }
  context.$router.push(fullPath)
}

const setFilters = (newFilters, context, prefix = '', withTz = false) => {
  for (const [key] of Object.entries(context.filters)) {
    const paramKey = prefix ? `${prefix}-${key}` : key

    if (newFilters[`${paramKey}`] !== undefined) {
      if (Number(newFilters[`${paramKey}`])) {
        context.filters[key] = Number(newFilters[`${paramKey}`])
      } else if (moment(newFilters[paramKey], ['YYYY-MM-DD HH:mm', 'DD.MM.YYYY HH:mm', 'YYYY-MM-DDTHH:mm:ssZ'], true).isValid()) {
        context.filters[key] = formatDate(newFilters[paramKey], withTz, false)
      } else {
        context.filters[key] = newFilters[`${paramKey}`]
      }
    } else {
      context.filters[key] = undefined
    }
  }
}

export { setQueryParams, setFilters }
